import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import divide from 'notebook/tables/excess/util/divide';

export default {
  name: 'CEILING',
  shortDescription: 'Rounds number up to nearest multiple of a factor.',
  category: FunctionCategory.MATH,
  description: 'Rounds a number up to the nearest integer multiple of specified significance.',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'The value to round up to the nearest integer multiple of factor.',
    },
    {
      name: 'factor',
      type: ArgType.number,
      optional: true,
      description: 'The number to whose multiples value will be rounded. Equals 1 if not specified.',
    },
  ],
  eval: (value: number, factor?: number): number => {
    factor ??= 1;
    if (factor < 0 && value > 0) {
      throw new util.NumericalError('CEILING parameter 1 must be negative if parameter 2 is negative');
    }
    if (factor === value && value === 0) {
      return 0;
    }
    return Math.ceil(divide(value, factor)) * factor;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
